var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"myIcon",attrs:{"src":require("../../assets/icons/chinese-temple.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }